import React, { useState, useEffect, useContext } from 'react';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import ResourceCard from '/src/Components/ResourceCard/ResourceCard';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import { BrickWall, MonitorPlay, ArrowLeft, Plus } from 'lucide-react';
import DIYGuidanceMaterials from './DIYGuidanceMaterials/DIYGuidanceMaterials';
import DIYGuidanceResources from './DIYGuidanceResources/DIYGuidanceResources';
import { AddressSearchContext } from '/src/App';
import './style.css';
// import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
// import SkusTable from '/src/Components/SkusTable/SkusTable';

const DIYGuidance = ({ propertyData, projects, companies, userPlanSelection }) => {

    const { portalData } = useContext(AddressSearchContext);

    const { resources, icons, skus } = portalData;


    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedProjectResources, setSelectedProjectResources] = useState([]);
    // const [resources, setResources] = useState([]);
    // const [icons, setIcons] = useState({});
    const [skusWithCompanyIcons, setSkusWithCompanyIcons] = useState([]);
    const [userPreferredRetailers, setUserPreferredRetailers] = useState([]);
    const [showSection, setShowSection] = useState(null);
    const [enrichedCompanies, setEnrichedCompanies] = useState([]);
    const [planProjectsWithDiyPreference, setPlanProjectsWithDiyPreference] = useState([]);
    const [noDIYProjectsSelection, setNoDIYProjectsSelection] = useState(null);
    // const [selectedVendor, setSelectedVendor] = useState(null);
    // const [selectedVendorProjects, setSelectedVendorProjects] = useState([]);
    // const [showSkuTable, setShowSkuTable] = useState(false);
    // const [skuTableReady, setSkuTableReady] = useState(false);
    // const [selectedProjectWithVendors, setSelectedProjectWithVendors] = useState(null);


    // Loading from LOCAL STORAGE resources, userPreferredRetailers, and skus
    useEffect(() => {
        // Load the user from localStorage
        const user = JSON.parse(localStorage.getItem('user'));
        const userPreferredRetailers = user.preferredRetailers || [];

        if (userPreferredRetailers.length > 0) {
            setUserPreferredRetailers(userPreferredRetailers);
        }
   

        // Only proceed if we have all required data
        if (skus && icons && companies) {
            const skusWithCompanyIconsLoading = skus.map(sku => {
                const company = companies.find(company => company.id === sku.sold_by);
                if (!company) return sku; // Return original sku if no company found

                const companyIconId = company.icon;
                const companyIconPath = icons[companyIconId];
                return {
                    ...sku,
                    company_icon: companyIconPath
                };
            });
            setSkusWithCompanyIcons(skusWithCompanyIconsLoading);
        }

        // If icons state is null, load icons from localStorage
        if (icons && companies) {

            // Map through companies and add icon paths
            const companiesWithIcons = companies.map(company => ({
                ...company,
                icon_path: icons[company.icon]
            }));
            setEnrichedCompanies(companiesWithIcons);
        }

        // if (Object.keys(icons).length > 0) {
        //     const companiesWithIcons = companies.map(company => ({
        //         ...company,
        //         icon_path: icons[company.icon]
        //     }));
        //     setEnrichedCompanies(companiesWithIcons);
        // }

        // If resources state is null, load resources from localStorage
        // if (resources.length === 0) {
        //     const loadedResources = JSON.parse(localStorage.getItem('resources'));
        //     setResources(loadedResources);
        // }

        // If skus state is null, load skus from localStorage
        // if (skus.length === 0) {
        //     try {
        //         const loadedSkus = JSON.parse(localStorage.getItem('skus'));
        //         const loadedIcons = JSON.parse(localStorage.getItem('icons'));
        //         const companiesData = JSON.parse(localStorage.getItem('companies'));

        //         // Only proceed if we have all required data
        //         if (loadedSkus && loadedIcons && companiesData) {
        //             const skusWithCompanyIcons = loadedSkus.map(sku => {
        //                 const company = companiesData.find(company => company.id === sku.sold_by);
        //                 if (!company) return sku; // Return original sku if no company found

        //                 const companyIconId = company.icon;
        //                 const companyIconPath = loadedIcons[companyIconId];
        //                 return {
        //                     ...sku,
        //                     company_icon: companyIconPath
        //                 };
        //             });
        //             setSkus(skusWithCompanyIcons);
        //             setIcons(loadedIcons);
        //         }
        //     } catch (error) {
        //         console.error('Error loading data from localStorage:', error);
        //     }
        // }

        // If icons state is null, load icons from localStorage
        // if (icons.length === 0) {
        //     const loadedIcons = JSON.parse(localStorage.getItem('icons'));

        //     // Map through companies and add icon paths
        //     const companiesWithIcons = companies.map(company => ({
        //         ...company,
        //         icon_path: loadedIcons[company.icon]
        //     }));
        //     setEnrichedCompanies(companiesWithIcons);
        //     setIcons(loadedIcons);
        // }

    }, [portalData]);

    // Once the icons are loaded then we create the enrichedCompanies array
    // useEffect(() => {
    //     if (Object.keys(icons).length > 0) {
    //         const companiesWithIcons = companies.map(company => ({
    //             ...company,
    //             icon_path: icons[company.icon]
    //         }));
    //         setEnrichedCompanies(companiesWithIcons);
    //     }

    // }, [icons]);

    // Get the projects in the plan
    const planProjects = userPlanSelection.projectData || [];
    const planProjectsCount = planProjects.length;

    // Get the project data for each project in the plan and add the diyPreference to the project data
    useEffect(() => {
        const planProjectsWithDiyPreferenceProcessing = planProjects.map(planProject => {
            const projectData = projects.find(p => p.project_id === planProject.project_id);

            // Transform the resource IDs into full resource objects
            const fullResources = projectData.project_associated_resources.map(resourceId =>
                resources.find(resource => resource.id === resourceId)
            ).filter(Boolean);

            // Transform the SKU IDs into full SKU objects and include the totalCost
            const fullSkus = projectData.project_skus.map(skuItem => {
                const fullSku = skusWithCompanyIcons.find(sku => sku.product_id === skuItem.id);
                if (!fullSku) return null;

                return {
                    ...fullSku,
                    totalCost: skuItem.cost
                };
            }).filter(Boolean); // Remove any undefined results if a SKU wasn't found

            return {
                ...projectData,
                diyPreference: planProject.diyPreference,
                project_associated_resources: fullResources,
                project_skus: fullSkus
            };
        }).sort((a, b) => {
            const aLength = a.project_discounts_company_specific?.length || 0;
            const bLength = b.project_discounts_company_specific?.length || 0;
            return bLength - aLength; // Sort in descending order (most discounts first)
        });
        setPlanProjectsWithDiyPreference(planProjectsWithDiyPreferenceProcessing);

        if (planProjectsWithDiyPreferenceProcessing.length > 0) {
            setNoDIYProjectsSelection(planProjectsWithDiyPreferenceProcessing[0]);
        }
    }, [planProjects, projects, resources, skusWithCompanyIcons]);

    // Combine the project_associated_resources from each project into a single array
    const allProjectAssociatedResources = planProjectsWithDiyPreference.flatMap(project => project.project_associated_resources);


    const projectsDIY = planProjectsWithDiyPreference.filter(project => project.diyPreference === 'diy');
    const projectsPro = planProjectsWithDiyPreference.filter(project => project.diyPreference === 'pro');
    const totalProjects = projectsDIY.length + projectsPro.length;
    // Get all unique sold_by values across all DIY projects
    const allSoldByValues = new Set(
        projectsDIY.flatMap(project =>
            project.project_skus.map(sku => sku.sold_by)
        )
    );

    // Create analysis objects for each sold_by value
    const soldByAnalysis = Array.from(allSoldByValues).map(soldBy => ({
        sold_by: soldBy,
        present_in_all: projectsDIY.every(project =>
            project.project_skus.some(sku => sku.sold_by === soldBy)
        ),
        present_in_list: projectsDIY
            .filter(project => project.project_skus.some(sku => sku.sold_by === soldBy))
            .map(project => {
                // Get all SKUs for this vendor in this project
                const vendorSkus = project.project_skus.filter(sku => sku.sold_by === soldBy);

                // Calculate the cost range
                const costs = vendorSkus.map(sku => sku.totalCost);
                const range_low = Math.min(...costs);
                const range_high = Math.max(...costs);

                return {
                    project_id: project.project_id,
                    range_low,
                    range_high
                };
            })
    }));

    // Get a boolean value, true if ANY of the objects in soldByAnalysis have present_in_all set to true
    const areAnyCompaniesPresentInAllProjects = soldByAnalysis.some(analysis => analysis.present_in_all);

    // Get the companies for which present_in_all is true
    const companiesPresentInAll = soldByAnalysis.filter(analysis => analysis.present_in_all);

    // console.log('enrichedCompanies ', enrichedCompanies);
    // console.log('areAnyCompaniesPresentInAllProjects ', areAnyCompaniesPresentInAllProjects);
    // console.log('soldByAnalysis ', soldByAnalysis);
    // console.log('userPreferredRetailers ', userPreferredRetailers);
    // console.log('skus ', skus);
    // console.log('planProjects ', planProjects);
    // console.log('resources ', resources);
    // console.log('planProjectsWithDiyPreference', planProjectsWithDiyPreference);
    // console.log('allProjectAssociatedResources', allProjectAssociatedResources);
    // console.log('projectsDIY', projectsDIY);
    // console.log('projectsPro', projectsPro);

    useEffect(() => {
        if (selectedProject && resources) {
            const projectResources = selectedProject.project_associated_resources;
            const filteredResources = resources.filter(resource => projectResources.includes(resource.id));
            setSelectedProjectResources(filteredResources);
        }
    }, [selectedProject, resources]);

    // Aggregate the resource ids from the selected projects using the project_associated_resources key
    const resourceIds = projects.map(project => project.project_associated_resources).flat();

    // Filter the resources array to only include the resources with ids that are in the resourceIds array
    // const filteredResources = resources.filter(resource => resourceIds.includes(resource.id));

    // Create a handler to set the selected project by taking a projectId and using it to find the project in the projects array
    const handleProjectSelect = (projectId) => {
        const project = projects.find(project => project.project_id === projectId);
        setSelectedProject(project);
    }

    // Create a handler to set the selectedProject to null
    const handleProjectDeselect = () => {
        setSelectedProject(null);
    }

    const handleSectionToggle = (section) => {
        // setSelectedVendor(null);
        // setSelectedVendorProjects([]);
        // setShowSkuTable(false);
        setShowSection(currentSection => currentSection === section ? null : section);
    };


    const sectionHeader = "DIY Guidance";
    const intro_sentence = `Fortune favors the bold! Taking on home improvements can be challenging, but we'll do our best to make your DIY projects as easy as possible. Select a project to get started.`;


    let DIYintroSentence = ''
    if (projectsDIY.length > 0) {
        DIYintroSentence = `Fortune favors the bold! We'll do our best to make your DIY projects as easy as possible. It looks like you have identified ${projectsDIY.length} project${projectsDIY.length === 1 ? '' : 's'} (of the ${totalProjects} in your plan) that you are planning on completing yourself.`;
    } else {
        DIYintroSentence = "It looks like you are planning on hiring professionals to complete the projects in your plan. Even so, we've compiled a list of resources that are useful for helping you understand the work that is going to be occuring. ";
    }

    const sections = [
        {
            id: 'materials',
            icon: <BrickWall />,
            label: 'Getting the Materials',
        },
        {
            id: 'guides',
            icon: <MonitorPlay />,
            label: 'Guides',
        },

    ]

    // Handler for clicking on a project card when there are no DIY projects
    const handleNoDIYProjectsClick = (project) => {

        // Get the project from the planProjectsWithDiyPreference array
        const projectFromPlan = planProjectsWithDiyPreference.find(p => p.project_id === project);

        if (noDIYProjectsSelection) {

            if (noDIYProjectsSelection.project_id === projectFromPlan.project_id) {
                setNoDIYProjectsSelection(null);
            } else {
                setNoDIYProjectsSelection(projectFromPlan);
            }
        } else {
            setNoDIYProjectsSelection(projectFromPlan);
        }
    }



    return (
        <div className="taking-action-section-container">
            <div className="taking-action-section-header">
                <h1>{sectionHeader}</h1>
                {/* <span className="taking-action-section-header-count"> {`( ${projectsDIY.length} of ${totalProjects} projects )`}</span> */}
            </div>

            {/* <h1>{sectionHeader}</h1> */}
            {!showSection && (
                <p className="text-align-center" dangerouslySetInnerHTML={{ __html: DIYintroSentence }} />
            )}
            {projectsDIY.length === 0 && (
                <div className={`diy-resources-section ${noDIYProjectsSelection ? 'has-selection' : ''}`}>

                    <div className="diy-resources-no-diy-projects-selection-container">
                        {planProjectsWithDiyPreference.map(project => (
                            <ProjectsListCard
                                selectedClassToAdd={noDIYProjectsSelection && noDIYProjectsSelection.project_id === project.project_id ? 'diy-resources-no-diy-projects-selection-project-card-selected' : ''}
                                key={project.project_id}
                                project={project}
                                isSelected={noDIYProjectsSelection && noDIYProjectsSelection.project_id === project.project_id}
                                handleProjectClick={handleNoDIYProjectsClick}
                                showAllDetails={false}
                                simulatorView={false}
                            />
                        ))}
                    </div>
                    {noDIYProjectsSelection && (
                        <>
                            <CurlyBraceDivider color="grey" />
                            <div className="diy-resources-no-diy-projects-selection-resources-container">
                                {noDIYProjectsSelection.project_associated_resources.map(resource => (
                                    <ResourceCard
                                        key={resource.id}
                                        resource={resource}
                                    />
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}
            {(projectsDIY.length > 0 && !showSection) &&
                <>

                    <div className="diy-projects-selection-content">
                        <div className="diy-projects-review-container">
                            {projectsDIY.map(project => (
                                <ProjectsListCard
                                    key={project.id}
                                    project={project}
                                    handleProjectClick={null}
                                    showAllDetails={false}
                                    simulatorView={false}
                                />
                            ))}

                        </div>
                        <CurlyBraceDivider />
                        <div className="diy-projects-review-section-selection-container">
                            {sections.map(section => (
                                <div
                                    className="diy-projects-review-section-selection-choice-container"
                                    onClick={() => handleSectionToggle(section)}
                                >
                                    <div className="diy-projects-review-section-selection-choice-icon-container">{section.icon}</div>
                                    <span className="diy-projects-review-section-selection-choice-label">{section.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            }
            {showSection &&
                <>
                    <div className="diy-projects-review-section-container">
                        <div className="diy-projects-review-section-selection-container">
                            <div
                                className="diy-projects-review-section-selection-choice-container small"
                                onClick={() => handleSectionToggle(null)}
                            >

                                <ArrowLeft />
                                <div className="diy-projects-review-section-selection-choice-icon-container small">{showSection.icon}</div>
                                <span className="diy-projects-review-section-selection-choice-label small">{showSection.label}</span>
                            </div>
                        </div>
                    </div>
                    {showSection.id === 'materials' && (
                        <DIYGuidanceMaterials
                            areAnyCompaniesPresentInAllProjects={areAnyCompaniesPresentInAllProjects}
                            companiesPresentInAll={companiesPresentInAll}
                            enrichedCompanies={enrichedCompanies}
                            projectsDIY={projectsDIY}
                            soldByAnalysis={soldByAnalysis}
                            planProjectsWithDiyPreference={planProjectsWithDiyPreference}
                        // handleVendorSelect={handleVendorSelect}
                        // showSkuTable={showSkuTable}
                        // setShowSkuTable={setShowSkuTable}
                        // setSkuTableReady={setSkuTableReady}
                        />
                    )}
                    {showSection.id === 'guides' && (
                        <DIYGuidanceResources projectsDIY={projectsDIY} propertyData={propertyData} />
                    )}
                </>

            }

        </div>
    );
}

export default DIYGuidance;